import BaseEndpoint from '@spa/apps/trustup-pro-base-js/endpoints/BaseEndpoint';
import TimeActivityCollection from '../collections/TimeActivityCollection';
import TimeActivityInProgressCollection from '../collections/TimeActivityInProgressCollection';
import TimeActivity from '../models/TimeActivity';

export default class TimeActivityEndpoint extends BaseEndpoint
{

    constructor()
    {
        super(
            'timetracker',
            {
                'path': 'time-activities',
                'responseKey': 'activity',
                'responseKeyPlural': 'activities',
                'modelClass': TimeActivity,
                'collectionClass': TimeActivityCollection
            }
        );
    }

    async week({before = '', worksites = null, users = null})
    {
        return await this.index({before, worksites, users}, `${this.path}/week`);
    }

    async table({before = '', worksites = null, users = null})
    {
        return await this.index({before, worksites, users}, `${this.path}/table`);
    }

    async calendar({before = '', worksites = null, users = null})
    {
        return await this.index({before, worksites, users}, `${this.path}/calendar`);
    }

    async inProgress()
    {
        let data = await this.request(`${this.path}/in-progress`);

        data[this.responseKeyPlural] = new TimeActivityInProgressCollection(
            data[this.responseKeyPlural]
        );
        
        return data;
    }

    async getPauses(uuid)
    {
        let {pauses} = await this.request(`${this.path}/${uuid}/pauses`);
        return pauses;
    }

    async startPause(uuid)
    {
        let response = await this.request(
            `${this.getPath()}/${uuid}/pauses/start`,
            'POST'
        );

        let model = response[this.responseKey] || null;
        if ( model ) {
            this.disableModelEvents();
            model = this.newModel(model);
            this.enableModelEvents();
            this.sendEvent(`${this.modelClass.getPrefix()}:updated`, model);
        }

        return model;
    }

    async stopPause(uuid)
    {
        let response = await this.request(
            `${this.getPath()}/${uuid}/pauses/stop-all`,
            'POST'
        );

        let model = response[this.responseKey] || null;
        if ( model ) {
            this.disableModelEvents();
            model = this.newModel(model);
            this.enableModelEvents();
            this.sendEvent(`${this.modelClass.getPrefix()}:updated`, model);
        }

        return model;
    }


}